import AxiosInstance from "../services/networkServices";

export const getOfficialInbox = async () => {
  const res = await AxiosInstance.get("/admin/messages/inbox");
  return res.data;
};

export const getOfficialDirectMessages = async (conversationId, params = {}) => {
  const res = await AxiosInstance.get(
    `/admin/messages/direct/${conversationId}`,
    { params }
  );
  return res.data;
};

export const sendOfficialDirectMessage = async (payload) => {
  const res = await AxiosInstance.post("/admin/messages/direct", payload);
  return res.data;
};

export const replyOfficialDirectMessage = async (conversationId, payload) => {
  const res = await AxiosInstance.post(
    `/admin/messages/direct/${conversationId}`,
    payload
  );
  return res.data;
};

export const sendOfficialSelected = async (payload) => {
  const res = await AxiosInstance.post("/admin/messages/send-selected", payload);
  return res.data;
};

export const markOfficialThreadRead = async (conversationId) => {
  const res = await AxiosInstance.post("/admin/messages/read", {
    conversationId,
  });
  return res.data;
};

export const searchOfficialMessageUsers = async (q = "") => {
  const res = await AxiosInstance.get("/admin/messages/users", {
    params: { q },
  });
  return res.data;
};
